import angular from 'angular';
import ngResource from 'angular-resource';
import apiSuppliersConfig from 'json!../../../config/api-suppliers.json';

class ApiSuppliersService {
    constructor($resource) {
        'ngInject';

        this.me = $resource(apiSuppliersConfig.baseUrl + apiSuppliersConfig.endpoint.me, {}, {
            get: {method: "GET"}
        });
    }
}

const apiSuppliersModule = angular.module('api.suppliers.suppliers', [
        ngResource
    ])
    .service('apiSuppliersService', ApiSuppliersService)
    .name;

export default apiSuppliersModule;



// WEBPACK FOOTER //
// ./client/app/api/suppliers.service.js